import React, { useEffect, useLayoutEffect } from "react";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import { createStyles, Theme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import Button from "@mui/material/Button";
import { useGoogleAPI } from "./useGoogleAPI";
import validatePhoneNumber from "./components/validatePhoneNumber";
import ToastNotification from "./components/ToastNotification";

export default function AutocompleteControlled(props) {
  const { auth, contacts, signinStatus, signout } = useGoogleAPI();

  const onchangeReason = {
    create: "createOption",
    select: "selectOption",
    remove: "removeOption",
  };

  // useEffect(() => {
  //   const storageContacts = JSON.parse(
  //     localStorage.getItem("useGoogleAPI")
  //   )?.contacts;
  //   if (storageContacts.length) props.setContactList(storageContacts);
  // }, []);

  // useEffect(() => {
  //   console.log(props.G_contacts);
  //   if (props.G_contacts && props.contactList.length == 0) {
  //     auth();
  //     window.location.reload();
  //   }
  //   // else {
  //   //   try {
  //   //     signout();
  //   //   } catch (err) {
  //   //     console.log(err);
  //   //   }
  //   // }
  // }, [props.G_contacts]);

  useEffect(() => {
    if (props.G_contacts && !contacts.length) return auth();
    if (!contacts || !contacts.length || !props.G_contacts) return;
    let userC = {};
    contacts
      .sort((ct1, ct2) =>
        ct1.names[0].displayName.toLowerCase() <
        ct2.names[0].displayName.toLowerCase()
          ? -1
          : 1
      )
      .forEach((ct) =>
        ct.phoneNumbers.forEach((number, index) => {
          userC[`${ct.names[0].displayName}(${number})`] = number;
        })
      );

    // userC = userC.filter(
    //   (a, i) => userC.findIndex((s) => a.name === s.name) === i
    // );
    props.setContactList(userC);
  }, [signinStatus, props.G_contacts, contacts]);

  return (
    <Autocomplete
      style={{ outline: "none" }}
      value={props.value}
      onChange={(event, newValue, reason, details) => {
        props.setNewOption("");
        //manual functionality after onchange

        //initial check
        if (
          !isNaN(props.newOption) &&
          !validatePhoneNumber(props.newOption) &&
          reason === onchangeReason.create
        ) {
          return ToastNotification({
            message: "Enter valid number",
          });
        }
        if (props.G_contacts && reason === onchangeReason.create) {
          return ToastNotification({
            message: "choose from option's",
          });
        }
        if (
          isNaN(props.newOption) &&
          !props.G_contacts &&
          reason === onchangeReason.create
        ) {
          return ToastNotification({
            message: "Eable Google contacts to search with name",
          });
        }

        props.setValue(newValue);
      }}
      multiple
      id="tags-filled"
      options={
        props.G_contacts && Object.keys(props.contactList)?.length
          ? Object.keys(props.contactList)
          : []
      }
      freeSolo
      renderTags={(value, getTagProps) => {
        // if (!props.value.length) return <div className="carousel"></div>;
        // else
        return (
          <div className="carousel">
            {value
              .map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option}
                  {...getTagProps({ index })}
                />
              ))
              .reverse()}
          </div>
        );
      }}
      renderInput={(params) => (
        <div style={{ display: "flex", position: "relative" }}>
          <TextField
            className="phoneNoInput"
            {...params}
            placeholder="88 88 888888"
            value={props.newOption}
            onChange={(event) => props.setNewOption(event.target.value)}
          />
          <Button
            // className=" btn-color"
            hidden={!validatePhoneNumber(props.newOption)}
            onClick={(e) => {
              props.setValue([...props.value, props.newOption]);
              props.setNewOption("");
              // manually trigger onChange function
              params.inputProps.onChange(
                e,
                props.newOption,
                onchangeReason.create
              );
            }}
            style={{ position: "absolute", bottom: "0px", left: "10px" }}
          >
            Add
          </Button>
        </div>
      )}
    />
  );
}
